import { render } from "./GalerySection.vue?vue&type=template&id=7887b45f&scoped=true"
import script from "./GalerySection.vue?vue&type=script&lang=js"
export * from "./GalerySection.vue?vue&type=script&lang=js"

import "./GalerySection.vue?vue&type=style&index=0&id=7887b45f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7887b45f"]])

export default __exports__